import { eur, num, showMoney } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { Store } from "lucide-react";

const Count = ({ p }) => {
  if (!p.store || !p.detail) return <span className="font-semibold">{num(p.value)}</span>;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="cursor-help font-semibold underline decoration-dotted underline-offset-4" data-testid={`province-count-${p.name}`}>{num(p.value)}</span>
      </TooltipTrigger>
      <TooltipContent side="left" data-testid={`province-tooltip-${p.name}`}>
        <p className="text-xs">Solo negozio: <b>{num(p.detail.negozio)}</b></p>
        <p className="text-xs">Negozio + online: <b>{num(p.detail.entrambi)}</b></p>
        <p className="text-xs">Solo online: <b>{num(p.detail.online)}</b></p>
        <p className="text-xs">Nessun ordine dal 2026: <b>{num(Math.max(0, p.value - p.detail.negozio - p.detail.entrambi - p.detail.online))}</b></p>
        <p className="mt-1 text-[10px] opacity-70">Canale calcolato sugli ordini dal 2026</p>
      </TooltipContent>
    </Tooltip>
  );
};

export const ProvinceList = ({ items, bare, onPick }) => {
  const rows = (
    <div className="space-y-0.5">
      {items.map((p) => (
        <div key={p.name} role={onPick ? "button" : undefined} onClick={onPick ? () => onPick(p.name) : undefined} title={onPick ? `Vedi le clienti di ${p.name}` : undefined}
          className={`flex items-center justify-between rounded px-1.5 py-1 text-sm ${onPick ? "cursor-pointer transition-colors hover:bg-secondary/60" : ""}`} data-testid={`geo-row-${p.name}`}>
          <span className="flex items-center gap-2 text-muted-foreground">
            {p.name}
            {p.store && (
              <Badge variant="outline" className="border-amber-500/30 bg-amber-500/10 px-1.5 py-0 text-[10px] text-amber-400" data-testid={`store-badge-${p.name}`}>
                <Store className="mr-1 h-3 w-3" />Negozio
              </Badge>
            )}
          </span>
          <span className="flex items-baseline gap-3"><Count p={p} /><span className="w-24 text-right text-xs text-muted-foreground">{showMoney() && (p.revenue != null || p.value != null) ? eur(p.revenue) : ""}</span></span>
        </div>
      ))}
    </div>
  );
  return (
    <TooltipProvider delayDuration={100}>
      {bare ? <div data-testid="customers-provinces">{rows}</div> : (
        <Card className="p-5" data-testid="customers-provinces">
          <p className="mb-3 font-mono-erp text-[11px] uppercase tracking-widest text-muted-foreground">Province</p>
          {rows}
        </Card>
      )}
    </TooltipProvider>
  );
};
